import { useEffect } from "react";
import { Table, Tag, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentHistory } from "../../actionCreator/paymentActionCreator";
import moment from "moment";

const InvoiceHistory = () => {
  const dispatch = useDispatch();
  const invoices = useSelector((state) => state.paymentReducer.invoices);

  useEffect(() => {
    dispatch(getPaymentHistory());
  }, [dispatch]);

  const handleDownload = async (invoiceUrl) => {
    window.open(invoiceUrl, "_blank");
  };

  const columns = [
    {
      title: "Invoice No",
      dataIndex: "invoiceId",
      key: "invoiceId",
    },
    {
      title: "Plan",
      dataIndex: "packageName",
      key: "packageName",
    },
    {
      title: "Date",
      dataIndex: "paymentDate",
      key: "paymentDate",
      render: (date) => {
        return moment(date).format("MMMM DD, YYYY");
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "default";
        if (status === "PAID") color = "green";
        if (status === "PENDING") color = "red";
        if (status === "FAILED") color = "red";

        return (
          <Tag color={color}>{status === "PENDING" ? "FAILED" : status}</Tag>
        );
      },
    },
    {
      title: "Amount ($)",
      dataIndex: "netAmount",
      key: "netAmount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space className="d-flex justify-content-center">
          <EyeOutlined onClick={() => handleDownload(record?.invoiceUrl)} />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ background: "#fff" }}>
      <Table
        columns={columns}
        dataSource={invoices?.content}
        pagination={{
          responsive: true,
          total: invoices?.totalCount,
          pageSize: 5,
          position: ["bottomCenter"],
        }}
        bordered
      />
    </div>
  );
};

export default InvoiceHistory;
